import type { ReglaError, SolicitudDetalle } from "@/lib/types";

/** Item de descarte devuelto por el endpoint de ZIP (subtipo F1/F2/F4/J/K). */
export interface DescarteZip {
  path: string;
  motivo: string;
  detalle: string | null;
}

/**
 * Resultado de procesar un ZIP · materializa F6 (mismo RFC receptor en
 * todos los CFDIs viables) y RN1-RN10 por CFDI. Vive en el feature en
 * vez de en `solicitudes-api.ts` para que la pantalla no dependa del
 * archivo legacy.
 */
export interface CargarZipResultado {
  solicitud: SolicitudDetalle;
  cfdisViables: number;
  descartes: DescarteZip[];
  archivosNoXmlNiPdfIgnorados: number;
  f6Autorizada: boolean;
  f6MotivoRechazo: string | null;
  reglasAutorizadas: boolean;
  erroresReglas: ReglaError[];
  /** Resultado del SAT por slot (vacío/ausente si el ZIP no llegó a consultarse). */
  resultadosSat?: ResultadoSatSlot[] | null;
  /**
   * `true` solo si TODOS los CFDIs quedaron vigentes ante el SAT. Un rechazo o una falta
   * de respuesta del SAT en cualquier slot lo deja en `false` aunque F6 y reglas pasen.
   */
  satTodosVigentes?: boolean;
}

/** Estado del SAT de un CFDI del ZIP · `Suspendido` = el SAT no respondió (no es rechazo). */
export interface ResultadoSatSlot {
  numeroSlot: number;
  uuid: string;
  estado: "Vigente" | "Rechazado" | "Suspendido";
  codigo: string | null;
  mensaje: string | null;
}

/** La carga del ZIP fue exitosa: F6 + reglas + SAT vigente en todos los CFDIs. */
export function zipCargadoCorrectamente(r: CargarZipResultado): boolean {
  return r.f6Autorizada && r.reglasAutorizadas && r.satTodosVigentes === true;
}
